var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "delete-modal",
      "visible": _vm.visible,
      "hide-footer": "",
      "centered": ""
    },
    on: {
      "hide": function hide($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "trash-wrap"
  }, [_c('i', {
    staticClass: "fa fa-triangle-exclamation"
  })]), _c('div', [_c('h6', {}, [_vm._v("Are you sure you want to delete ?")]), _c('p', {
    staticClass: "light-txt"
  }, [_vm._v(" The action can't be undone.this will be permanently deleted and removed from our records. If you are sure , please confirm your decision. ")])])]), _c('div', {
    staticClass: "d-flex justify-content-end mt-3 gap-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Close")]), _c('b-button', {
    staticClass: "univ-btn univ-delete m-0 p-0 w-fit",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('delete');
      }
    }
  }, [_vm._v("Delete")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }